import { render, staticRenderFns } from "./expgroup.vue?vue&type=template&id=15f3e3b8"
import script from "./expgroup.vue?vue&type=script&lang=js"
export * from "./expgroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports